export const SendAgainIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66406 7.99983C2.66447 10.6901 4.66772 12.9593 7.33721 13.2933C10.0067 13.6273 12.5073 11.9216 13.1705 9.31438C13.8337 6.70712 12.4521 4.01392 9.94753 3.03174C7.44293 2.04957 4.59889 3.08568 3.313 5.44877"
      stroke="#761873"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.36418 5.44824H3.00586L3.00586 3.08993"
      stroke="#761873"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.04167 7.58074L5.04312 7.5822C5.04393 7.58301 5.04393 7.58431 5.04312 7.58512V7.58512C5.04232 7.58592 5.04101 7.58592 5.04021 7.58512V7.58512C5.0394 7.58431 5.0394 7.58301 5.04021 7.5822L5.04167 7.58074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.79167 7.58074L6.79312 7.5822C6.79393 7.58301 6.79393 7.58431 6.79312 7.58512V7.58512C6.79232 7.58592 6.79101 7.58592 6.79021 7.58512V7.58512C6.7894 7.58431 6.7894 7.58301 6.79021 7.5822L6.79167 7.58074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.54167 7.58074L8.54313 7.5822C8.54393 7.58301 8.54393 7.58431 8.54313 7.58512V7.58512C8.54232 7.58592 8.54101 7.58592 8.54021 7.58512V7.58512C8.5394 7.58431 8.5394 7.58301 8.54021 7.5822L8.54167 7.58074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2917 7.58074L10.2931 7.5822C10.2939 7.58301 10.2939 7.58431 10.2931 7.58512V7.58512C10.2923 7.58592 10.291 7.58592 10.2902 7.58512V7.58512C10.2894 7.58431 10.2894 7.58301 10.2902 7.5822L10.2917 7.58074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.04167 9.33074L5.04312 9.3322C5.04393 9.33301 5.04393 9.33431 5.04312 9.33512V9.33512C5.04232 9.33592 5.04101 9.33592 5.04021 9.33512V9.33512C5.0394 9.33431 5.0394 9.33301 5.04021 9.3322L5.04167 9.33074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.79167 9.33074L6.79312 9.3322C6.79393 9.33301 6.79393 9.33431 6.79312 9.33512V9.33512C6.79232 9.33592 6.79101 9.33592 6.79021 9.33512V9.33512C6.7894 9.33431 6.7894 9.33301 6.79021 9.3322L6.79167 9.33074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.54167 9.33074L8.54313 9.3322C8.54393 9.33301 8.54393 9.33431 8.54313 9.33512V9.33512C8.54232 9.33592 8.54101 9.33592 8.54021 9.33512V9.33512C8.5394 9.33431 8.5394 9.33301 8.54021 9.3322L8.54167 9.33074"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2.41699"
      y="1.75"
      width="10.5"
      height="10.5"
      rx="2"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.41699 5.24967H12.917"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.69851 6.40663C9.26803 6.97614 9.26803 7.89951 8.69851 8.46902C8.129 9.03854 7.20563 9.03854 6.63612 8.46902C6.06661 7.89951 6.06661 6.97614 6.63612 6.40663C7.20564 5.83711 8.129 5.83711 8.69851 6.40663"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8987 2.90663C12.4682 3.47614 12.4682 4.39951 11.8987 4.96902C11.3292 5.53854 10.4058 5.53854 9.83632 4.96902C9.2668 4.39951 9.2668 3.47614 9.83632 2.90663C10.4058 2.33711 11.3292 2.33711 11.8987 2.90663"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.167 7.14648C12.0612 7.14648 12.917 7.4574 13.5003 7.92407"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.49832 2.90663C6.06783 3.47614 6.06783 4.39951 5.49832 4.96902C4.9288 5.53854 4.00544 5.53854 3.43593 4.96902C2.86641 4.39951 2.86641 3.47614 3.43593 2.90663C4.00544 2.33711 4.9288 2.33711 5.49832 2.90663"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.83398 7.92407C2.41732 7.4574 3.27307 7.14648 4.16732 7.14648"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3454 11.5215C9.66584 10.9959 8.68934 10.6465 7.66734 10.6465C6.64534 10.6465 5.66884 10.9959 4.98926 11.5215"
      stroke="#7B808C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AnnouncementIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9987 15.0011L6.99776 14.9991C4.78784 14.9991 2.99609 13.2063 2.99609 10.9954V9.99801C2.99609 7.78709 4.78784 5.99535 6.99876 5.99535H13.9997L17.8733 3.34824C19.2018 2.44086 21.0036 3.39226 21.0036 5.00093V15.9975C21.0036 17.6062 19.2008 18.5576 17.8733 17.6492L13.9987 15.0011Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0002 5.99707V15.0008"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.99805 15.001L7.52768 18.8606C7.8008 19.5509 8.46307 20.0031 9.19838 20.0031V20.0031C10.4699 20.0031 11.3403 18.7085 10.8711 17.515L9.88166 15.001"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomDownloadIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.25H8.25C7.69772 4.25 7.25 3.80228 7.25 3.25V1.5"
      stroke="#320B30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.5V10"
      stroke="#320B30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 9L6 10L7 9"
      stroke="#320B30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.5H8.5C9.32843 10.5 10 9.82843 10 9V4.12132C10 3.7235 9.84196 3.34196 9.56066 3.06066L8.43934 1.93934C8.15804 1.65804 7.7765 1.5 7.37868 1.5H3.5C2.67157 1.5 2 2.17157 2 3V9C2 9.82843 2.67157 10.5 3.5 10.5H4"
      stroke="#320B30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RequeueIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 9.99935L9.99996 6.66601M9.99996 6.66601L6.66663 9.99935M9.99996 6.66601V14.3327C9.99996 15.4916 9.99996 16.0711 10.4587 16.7199C10.7635 17.1509 11.6411 17.6829 12.1643 17.7538C12.9517 17.8605 13.2507 17.7045 13.8488 17.3926C16.5138 16.0023 18.3333 13.2133 18.3333 9.99935C18.3333 5.39697 14.6023 1.66602 9.99996 1.66602C5.39758 1.66602 1.66663 5.39698 1.66663 9.99935C1.66663 13.0839 3.34245 15.777 5.83329 17.2178"
      stroke="#320b30"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 8.33333C17.5 8.33333 15.8291 6.05685 14.4718 4.69854C13.1144 3.34022 11.2386 2.5 9.16663 2.5C5.02449 2.5 1.66663 5.85786 1.66663 10C1.66663 14.1421 5.02449 17.5 9.16663 17.5C12.5859 17.5 15.4707 15.2119 16.3735 12.0833M17.5 8.33333V3.33333M17.5 8.33333H12.5"
      stroke="#320b30"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckVerifyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49996 9.99935L9.16663 11.666L12.9166 7.91602M7.66821 17.1667C7.94133 17.1306 8.21724 17.2047 8.43481 17.3723L9.43751 18.1417C9.76896 18.3963 10.23 18.3963 10.5606 18.1417L11.6012 17.3427C11.7956 17.1936 12.041 17.1279 12.2836 17.1603L13.5853 17.3316C13.9992 17.3862 14.3982 17.1556 14.5584 16.7695L15.0593 15.5585C15.1528 15.3316 15.3324 15.152 15.5592 15.0585L16.7702 14.5576C17.1563 14.3983 17.3868 13.9983 17.3322 13.5844L17.1674 12.3298C17.1313 12.0567 17.2054 11.7808 17.373 11.5632L18.1423 10.5604C18.3969 10.229 18.3969 9.76787 18.1423 9.43733L17.3433 8.39662C17.1943 8.20218 17.1285 7.95681 17.1609 7.71423L17.3322 6.41241C17.3868 5.99854 17.1563 5.59947 16.7702 5.43929L15.5592 4.93838C15.3324 4.84486 15.1528 4.66524 15.0593 4.43839L14.5584 3.22731C14.3991 2.84121 13.9992 2.61067 13.5853 2.66529L12.2836 2.83658C12.041 2.86992 11.7956 2.80418 11.6021 2.65603L10.5615 1.85698C10.23 1.60236 9.76896 1.60236 9.43843 1.85698L8.39778 2.65603C8.20335 2.80418 7.958 2.86992 7.71543 2.83844L6.41368 2.66715C5.99983 2.61252 5.60079 2.84307 5.44062 3.22917L4.94066 4.44024C4.84622 4.66616 4.66661 4.84579 4.4407 4.94023L3.22969 5.44022C2.84361 5.6004 2.61307 5.99946 2.6677 6.41334L2.83898 7.71515C2.87046 7.95774 2.80473 8.2031 2.65659 8.39662L1.85758 9.43733C1.60297 9.7688 1.60297 10.2299 1.85758 10.5604L2.65659 11.6012C2.80565 11.7956 2.87139 12.041 2.83898 12.2835L2.6677 13.5854C2.61307 13.9992 2.84361 14.3983 3.22969 14.5585L4.4407 15.0594C4.66753 15.1529 4.84715 15.3325 4.94066 15.5594L5.44154 16.7705C5.60079 17.1566 6.00076 17.3871 6.41461 17.3325L7.66821 17.1667Z"
      stroke="#320b30"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClearLimitIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.6665L13.3333 9.99984M13.3333 9.99984L10 13.3332M13.3333 9.99984H2.5M2.78152 5.83317C4.22239 3.34233 6.91549 1.6665 10 1.6665C14.6024 1.6665 18.3333 5.39746 18.3333 9.99984C18.3333 14.6022 14.6024 18.3332 10 18.3332C6.91549 18.3332 4.22239 16.6573 2.78152 14.1665"
      stroke="#320b30"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeactivateIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.6504 28.0489C19.7048 26.8621 14.3757 27.6005 9.92292 30.2519C9.58712 30.4519 9.21916 30.6605 8.83372 30.8793C7.4085 31.6879 5.74446 32.6319 4.58428 33.7675C3.86402 34.4725 3.557 35.0541 3.50788 35.5033C3.4689 35.8601 3.55908 36.4483 4.46034 37.3069C6.53204 39.2807 8.6372 40.4999 11.1821 40.4999H24.0004C24.8288 40.4999 25.5004 41.1715 25.5004 41.9999C25.5004 42.8283 24.8288 43.4999 24.0004 43.4999H11.1821C7.54548 43.4999 4.7339 41.7111 2.391 39.4791C1.03296 38.1853 0.356039 36.7291 0.525659 35.1775C0.685139 33.7183 1.56246 32.5273 2.48578 31.6235C3.96212 30.1785 6.11714 28.9627 7.54276 28.1585C7.8681 27.9749 8.15544 27.8127 8.38808 27.6743C13.5322 24.6113 19.666 23.7677 25.3502 25.1317C26.1558 25.3249 26.6522 26.1347 26.459 26.9403C26.2656 27.7457 25.4558 28.2421 24.6504 28.0489Z"
      fill="#7A010E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0001 3.5C17.8579 3.5 14.5 6.85786 14.5 11C14.5 15.1421 17.8579 18.5 22.0001 18.5C26.1421 18.5 29.5001 15.1421 29.5001 11C29.5001 6.85786 26.1421 3.5 22.0001 3.5ZM11.5 11C11.5 5.201 16.201 0.5 22.0001 0.5C27.7989 0.5 32.5001 5.201 32.5001 11C32.5001 16.799 27.7989 21.5 22.0001 21.5C16.201 21.5 11.5 16.799 11.5 11Z"
      fill="#7A010E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.5 35C26.5 30.3056 30.3054 26.5 35 26.5C39.6944 26.5 43.5 30.3056 43.5 35C43.5 39.6944 39.6944 43.5 35 43.5C30.3054 43.5 26.5 39.6944 26.5 35ZM30.1968 32.3182C29.753 33.1116 29.5 34.0262 29.5 35C29.5 38.0376 31.9624 40.5 35 40.5C35.9736 40.5 36.8882 40.247 37.6816 39.803L30.1968 32.3182ZM32.3182 30.197L39.803 37.6818C40.2468 36.8884 40.5 35.9738 40.5 35C40.5 31.9624 38.0374 29.5 35 29.5C34.0262 29.5 33.1116 29.753 32.3182 30.197Z"
      fill="#7A010E"
    />
  </svg>
);

export const ReactivateIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.4138 25.4997C43.6904 26.2807 43.2816 27.1379 42.5006 27.4145C41.3472 27.8229 40.0586 28.6833 38.7316 29.8471C37.42 30.9971 36.1514 32.3719 35.034 33.7113C33.9196 35.0473 32.9738 36.3261 32.3062 37.2717C31.973 37.7439 31.7104 38.1311 31.5324 38.3985C31.4432 38.5321 31.3754 38.6357 31.3304 38.7051L31.2804 38.7825L31.2686 38.8007L31.2662 38.8045C31.2662 38.8045 31.266 38.8049 30 38.0005C28.7338 37.1961 28.7342 37.1957 28.7342 37.1957L28.7404 37.1857L28.7562 37.1611L28.8148 37.0705C28.8632 36.9961 28.9324 36.8903 29.0212 36.7567C29.026 36.7497 29.0308 36.7425 29.0356 36.7353C29.2268 36.4481 29.5048 36.0383 29.8554 35.5417C29.9262 35.4415 30 35.3375 30.0766 35.2303C30.7586 34.2769 31.6702 33.0607 32.7304 31.7897C33.9072 30.3791 35.2856 28.8789 36.7536 27.5915C38.206 26.3177 39.829 25.1781 41.4992 24.5865C42.28 24.3099 43.1372 24.7189 43.4138 25.4997ZM26 34.0005V32.5005C25.1714 32.5005 24.5 33.1721 24.5 34.0005C24.5 34.7955 25.1186 35.4461 25.9006 35.4973C25.908 35.4989 25.9184 35.5015 25.9316 35.5053C26.0026 35.5255 26.1732 35.5855 26.4178 35.7485C26.9042 36.0729 27.7472 36.8493 28.6582 38.6713C28.9 39.1549 29.3832 39.4709 29.9232 39.4985C30.463 39.5261 30.9762 39.2607 31.2662 38.8045M26 34.0005C26 32.5005 26.0028 32.5005 26.0028 32.5005H26.0058H26.012L26.025 32.5007L26.0534 32.5013C26.0732 32.5021 26.0954 32.5031 26.1194 32.5045C26.1676 32.5077 26.224 32.5129 26.288 32.5215C26.416 32.5385 26.5736 32.5687 26.7558 32.6207C27.1222 32.7255 27.5766 32.9155 28.082 33.2525C28.7086 33.6703 29.3902 34.2975 30.0766 35.2303"
      fill="#005229"
    />
    <path
      d="M29.0212 36.7562C29.026 36.7492 29.0308 36.742 29.0356 36.7348C29.2268 36.4476 29.5048 36.0378 29.8554 35.5412C29.9262 35.441 30 35.337 30.0766 35.2298L26 34L29.0212 36.7562Z"
      fill="#005229"
    />
    <path
      d="M30.0002 37.9997C31.22 38.7747 31.2664 38.8037 31.2664 38.8037L29.0214 36.7559C28.9326 36.8895 28.8634 36.9953 28.815 37.0697L28.7564 37.1603L28.7406 37.1849L28.7344 37.1949C28.7344 37.1949 28.734 37.1953 30.0002 37.9997Z"
      fill="#005229"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.2938 29.8096C23.2604 26.5884 15.8257 26.7372 9.92292 30.252C9.58712 30.452 9.21916 30.6606 8.83372 30.8794C7.4085 31.688 5.74446 32.632 4.58428 33.7676C3.86402 34.4726 3.557 35.0542 3.50788 35.5034C3.4689 35.8602 3.55908 36.4484 4.46034 37.307C6.53204 39.2808 8.6372 40.5 11.1821 40.5H24.0004C24.8288 40.5 25.5004 41.1716 25.5004 42C25.5004 42.8284 24.8288 43.5 24.0004 43.5H11.1821C7.54548 43.5 4.7339 41.7112 2.391 39.4792C1.03296 38.1854 0.356039 36.7292 0.525659 35.1776C0.685139 33.7184 1.56246 32.5274 2.48578 31.6236C3.96212 30.1786 6.11714 28.9628 7.54276 28.1586C7.8681 27.975 8.15544 27.8128 8.38808 27.6744C15.1987 23.619 23.7518 23.45 30.7068 27.1632C31.4376 27.5534 31.7136 28.4622 31.3236 29.193C30.9334 29.9238 30.0246 30.1998 29.2938 29.8096Z"
      fill="#005229"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0001 3.5C17.8579 3.5 14.5 6.85786 14.5 11C14.5 15.1421 17.8579 18.5 22.0001 18.5C26.1421 18.5 29.5001 15.1421 29.5001 11C29.5001 6.85786 26.1421 3.5 22.0001 3.5ZM11.5 11C11.5 5.201 16.201 0.5 22.0001 0.5C27.7989 0.5 32.5001 5.201 32.5001 11C32.5001 16.799 27.7989 21.5 22.0001 21.5C16.201 21.5 11.5 16.799 11.5 11Z"
      fill="#005229"
    />
  </svg>
);

export const ConfirmationSuspendDeactivateIcon = () => (
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.6654 27.8442C53.6654 40.7439 42.7046 51.353 29.0011 51.3554H28.996C27.3896 51.3575 25.7875 51.209 24.2088 50.9125L24.1627 50.9039C23.5903 50.7965 23.0899 50.7023 22.681 50.6463C22.2718 50.5901 21.7802 50.5442 21.2741 50.6215C20.7544 50.701 20.2745 50.9079 19.8899 51.0906C19.7245 51.1693 19.5435 51.2599 19.3473 51.3613C19.0719 51.5031 18.7666 51.6655 18.4331 51.8429L18.3929 51.8642C16.2768 52.9895 13.9169 53.6058 11.5333 53.6621C12.1823 52.3506 12.6537 50.9479 12.9308 49.4933L12.9314 49.4898C12.9791 49.2375 13.0081 48.9885 13.0202 48.7434C13.1179 46.7762 12.1319 45.0666 11.0074 43.9247C6.85723 39.7103 4.33203 34.0551 4.33203 27.8442C4.33203 26.6543 4.42528 25.4839 4.60531 24.3394C6.37731 13.0761 16.557 4.33301 28.9987 4.33301C29.4144 4.33301 29.8275 4.34279 30.2379 4.36213C31.3414 4.41413 32.2779 3.56183 32.3299 2.4585C32.3819 1.35514 31.5296 0.418555 30.4262 0.366581C29.9531 0.344288 29.4771 0.333008 28.9987 0.333008C13.2526 0.333008 0.332031 12.5687 0.332031 27.8442C0.332031 35.1714 3.31792 41.817 8.15734 46.7311C8.87155 47.4565 9.10376 48.1999 9.00099 48.7471C8.62163 50.7367 7.7639 52.585 6.51648 54.1194C6.07134 54.6669 5.94766 55.4085 6.19104 56.0709C6.43443 56.733 7.00886 57.2181 7.70259 57.3471C11.9988 58.1463 16.4531 57.4263 20.271 55.3959C20.8938 55.0647 21.3006 54.849 21.606 54.7039C21.7505 54.6351 21.8384 54.5994 21.8837 54.5821C21.9275 54.5847 22.0078 54.5914 22.1373 54.6093C22.4363 54.6501 22.8381 54.725 23.4706 54.8439C25.2928 55.1861 27.1456 55.3578 29.0014 55.3554C44.7462 55.3541 57.6654 43.1189 57.6654 27.8442C57.6654 27.2962 57.6486 26.7517 57.6155 26.2111C57.5483 25.1085 56.6 24.2693 55.4974 24.3367C54.395 24.4039 53.5558 25.3525 53.623 26.4549C53.6512 26.9143 53.6654 27.3775 53.6654 27.8442Z"
      fill="#7A010E"
    />
    <path
      d="M29.0431 28.122C29.0512 28.1094 29.0598 28.0967 29.0683 28.0839C29.4086 27.5733 29.9024 26.845 30.5257 25.9621C30.6516 25.7838 30.7827 25.5991 30.9193 25.4084L23.6719 23.2222L29.0431 28.122Z"
      fill="#7A010E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.0056 11.5139C54.3937 11.0222 55.1208 9.49831 54.6291 8.11009C54.1373 6.72187 52.6135 5.99507 51.2251 6.48672C48.2563 7.53827 45.3707 9.56434 42.7887 11.8287C40.1791 14.1172 37.7286 16.7842 35.637 19.2917C33.7519 21.5513 32.1317 23.7135 30.9193 25.4083C29.6991 23.7501 28.4874 22.635 27.3731 21.8922C26.4746 21.2933 25.6672 20.9553 25.0155 20.7692C24.6916 20.6767 24.4118 20.6231 24.1839 20.5928C24.0704 20.5776 23.9702 20.5683 23.8845 20.5628C23.8415 20.56 23.8024 20.5582 23.7668 20.557L23.7163 20.5559L23.6936 20.5556L23.6825 20.5555H23.6772C23.6772 20.5555 23.6719 20.5555 23.6719 23.222L30.9193 25.4083C30.7827 25.599 30.6515 25.7837 30.5257 25.9619C29.9024 26.8449 29.4086 27.5732 29.0683 28.0838L29.0431 28.1218L33.0337 31.7623L33.0383 31.7555L33.0589 31.7229L33.1482 31.5853C33.2278 31.4623 33.3487 31.2781 33.5069 31.0404C33.8237 30.565 34.2905 29.8767 34.8829 29.0375C36.0693 27.3563 37.7507 25.0831 39.7321 22.7081C41.7186 20.3269 43.9738 17.883 46.3051 15.8383C48.6641 13.7695 50.9552 12.2401 53.0056 11.5139Z"
      fill="#7A010E"
    />
    <path
      d="M30.7776 30.3332C32.946 31.7109 33.0285 31.7626 33.0285 31.7626L29.0379 28.1221C28.88 28.3595 28.7567 28.5476 28.671 28.6797L28.5668 28.8409L28.5387 28.8848L28.5273 28.9024C28.5273 28.9024 28.5266 28.9033 30.7776 30.3332Z"
      fill="#7A010E"
    />
    <path
      d="M30.7774 30.3331C28.5265 28.9032 28.5272 28.9023 28.5272 28.9023L28.5386 28.8848L28.5667 28.8409L28.6709 28.6797C28.7565 28.5476 28.8799 28.3594 29.0378 28.122L23.6666 23.2222V20.5557C22.1939 20.5557 21 21.7495 21 23.2222C21 24.6357 22.0997 25.7923 23.4902 25.8831C23.503 25.886 23.5215 25.8906 23.545 25.8974C23.6712 25.9334 23.9748 26.0399 24.4097 26.3298C25.2743 26.9063 26.773 28.2866 28.3925 31.5256C28.8223 32.3852 29.6813 32.9471 30.6409 32.9962C31.6005 33.0453 32.5132 32.5735 33.0284 31.7625C33.0284 31.7625 32.9459 31.7108 30.7774 30.3331Z"
      fill="#7A010E"
    />
  </svg>
);

export const ConfirmationApproveReactivateIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M58.6654 30.8445C58.6654 44.933 46.7246 56.3557 31.9987 56.3557C30.2672 56.3581 28.5406 56.1978 26.8398 55.8786C25.6156 55.6485 25.0034 55.5335 24.5761 55.5989C24.1488 55.6642 23.5432 55.9863 22.332 56.6303C18.9057 58.4525 14.9106 59.0959 11.0683 58.3813C12.5287 56.585 13.526 54.4298 13.9661 52.1194C14.2328 50.7061 13.572 49.3333 12.5824 48.3282C8.08758 43.7639 5.33203 37.6135 5.33203 30.8445C5.33203 16.7561 17.2728 5.33325 31.9987 5.33325C46.7246 5.33325 58.6654 16.7561 58.6654 30.8445Z"
      fill="#F1EFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.6654 30.8444C56.6654 43.7442 45.7046 54.3532 32.0011 54.3556H31.996C30.3896 54.3578 28.7875 54.2093 27.2088 53.9127L27.1627 53.9042C26.5903 53.7967 26.0899 53.7026 25.681 53.6466C25.2718 53.5903 24.7802 53.5444 24.2741 53.6218C23.7544 53.7012 23.2745 53.9082 22.8899 54.0908C22.7245 54.1695 22.5435 54.2602 22.3473 54.3615C22.0719 54.5034 21.7666 54.6658 21.4331 54.8431L21.3929 54.8644C19.2768 55.9898 16.9169 56.606 14.5333 56.6623C15.1823 55.3508 15.6537 53.9482 15.9308 52.4935L15.9314 52.49C15.9791 52.2378 16.0081 51.9887 16.0202 51.7436C16.1179 49.7765 15.1319 48.0669 14.0074 46.925C9.85723 42.7106 7.33203 37.0554 7.33203 30.8444C7.33203 29.6546 7.42528 28.4842 7.60531 27.3397C9.37731 16.0763 19.557 7.33325 31.9987 7.33325C32.4144 7.33325 32.8275 7.34304 33.2379 7.36237C34.3414 7.41437 35.2779 6.56208 35.3299 5.45875C35.3819 4.35539 34.5296 3.4188 33.4262 3.36683C32.9531 3.34453 32.4771 3.33325 31.9987 3.33325C16.2526 3.33325 3.33203 15.569 3.33203 30.8444C3.33203 38.1716 6.31792 44.8172 11.1573 49.7314C11.8716 50.4567 12.1038 51.2002 12.001 51.7474C11.6216 53.737 10.7639 55.5853 9.51648 57.1197C9.07134 57.6671 8.94766 58.4087 9.19104 59.0711C9.43443 59.7332 10.0089 60.2183 10.7026 60.3474C14.9988 61.1466 19.4531 60.4266 23.271 58.3962C23.8938 58.065 24.3006 57.8492 24.606 57.7042C24.7505 57.6354 24.8384 57.5996 24.8837 57.5823C24.9275 57.585 25.0078 57.5916 25.1373 57.6095C25.4363 57.6503 25.8381 57.7253 26.4706 57.8442C28.2928 58.1863 30.1456 58.358 32.0014 58.3556C47.7462 58.3543 60.6654 46.1191 60.6654 30.8444C60.6654 30.2964 60.6486 29.7519 60.6155 29.2114C60.5483 28.1087 59.6 27.2695 58.4974 27.337C57.395 27.4042 56.5558 28.3527 56.623 29.4551C56.6512 29.9146 56.6654 30.3778 56.6654 30.8444Z"
      fill="#005229"
    />
    <path
      d="M32.0431 31.1222C32.0512 31.1096 32.0598 31.097 32.0683 31.0842C32.4086 30.5736 32.9024 29.8452 33.5257 28.9623C33.6516 28.784 33.7827 28.5993 33.9193 28.4087L26.6719 26.2224L32.0431 31.1222Z"
      fill="#005229"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.0056 14.5139C57.3937 14.0222 58.1208 12.4983 57.6291 11.1101C57.1373 9.72187 55.6135 8.99507 54.2251 9.48672C51.2563 10.5383 48.3707 12.5643 45.7887 14.8287C43.1791 17.1172 40.7286 19.7842 38.637 22.2917C36.7519 24.5513 35.1317 26.7135 33.9193 28.4083C32.6991 26.7501 31.4874 25.635 30.3731 24.8922C29.4746 24.2933 28.6672 23.9553 28.0155 23.7692C27.6916 23.6767 27.4118 23.6231 27.1839 23.5928C27.0704 23.5776 26.9702 23.5683 26.8845 23.5628C26.8415 23.56 26.8024 23.5582 26.7668 23.557L26.7163 23.5559L26.6936 23.5556L26.6825 23.5555H26.6772C26.6772 23.5555 26.6719 23.5555 26.6719 26.222L33.9193 28.4083C33.7827 28.599 33.6515 28.7837 33.5257 28.9619C32.9024 29.8449 32.4086 30.5732 32.0683 31.0838L32.0431 31.1218L36.0337 34.7623L36.0383 34.7555L36.0589 34.7229L36.1482 34.5853C36.2278 34.4623 36.3487 34.2781 36.5069 34.0404C36.8237 33.565 37.2905 32.8767 37.8829 32.0375C39.0693 30.3563 40.7507 28.0831 42.7321 25.7081C44.7186 23.3269 46.9738 20.883 49.3051 18.8383C51.6641 16.7695 53.9552 15.2401 56.0056 14.5139Z"
      fill="#005229"
    />
    <path
      d="M33.7776 33.3336C35.946 34.7114 36.0285 34.7631 36.0285 34.7631L32.0379 31.1226C31.88 31.36 31.7567 31.5481 31.671 31.6802L31.5668 31.8414L31.5387 31.8853L31.5273 31.9029C31.5273 31.9029 31.5266 31.9038 33.7776 33.3336Z"
      fill="#005229"
    />
    <path
      d="M33.7774 33.3331C31.5265 31.9032 31.5272 31.9023 31.5272 31.9023L31.5386 31.8848L31.5667 31.8409L31.6709 31.6797C31.7565 31.5476 31.8799 31.3594 32.0378 31.122L26.6666 26.2222V23.5557C25.1939 23.5557 24 24.7495 24 26.2222C24 27.6357 25.0997 28.7923 26.4902 28.8831C26.503 28.886 26.5215 28.8906 26.545 28.8974C26.6712 28.9334 26.9748 29.0399 27.4097 29.3298C28.2743 29.9063 29.773 31.2866 31.3925 34.5256C31.8223 35.3852 32.6813 35.9471 33.6409 35.9962C34.6005 36.0453 35.5132 35.5735 36.0284 34.7625C36.0284 34.7625 35.9459 34.7108 33.7774 33.3331Z"
      fill="#005229"
    />
  </svg>
);

export const SmileyFace = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3562 16.5H7.64453C4.88286 16.5 2.64453 14.2617 2.64453 11.5V6.5C2.64453 3.73833 4.88286 1.5 7.64453 1.5H12.3554C15.117 1.5 17.3554 3.73833 17.3554 6.5V11.5C17.3562 14.2617 15.117 16.5 12.3562 16.5Z"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33464 6.91699V7.75033"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 6.91699V7.75033"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0013 11.9171C11.8246 11.9171 12.918 10.8237 12.918 10.8237"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08333 10.8237C7.08333 10.8237 8.17667 11.9171 10 11.9171"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SadSmileyFace = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3562 16.5H7.64453C4.88286 16.5 2.64453 14.2617 2.64453 11.5V6.5C2.64453 3.73833 4.88286 1.5 7.64453 1.5H12.3554C15.117 1.5 17.3554 3.73833 17.3554 6.5V11.5C17.3562 14.2617 15.117 16.5 12.3562 16.5Z"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33464 6.91699V7.75033"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 6.91699V7.75033"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0013 10.8237C11.8246 10.8237 12.918 11.917 12.918 11.917"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08333 11.917C7.08333 11.917 8.17667 10.8237 10 10.8237"
      stroke="#24272E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SuspendIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05026 6.15821C5 8.31637 5 11.7899 5 18.7369V29.2632C5 36.2102 5 39.6838 7.05026 41.842C9.1005 44 12.4003 44 19 44H25C31.5996 44 34.8994 44 36.9498 41.842C39 39.6838 39 36.2102 39 29.2632V18.7369C39 11.7899 39 8.31637 36.9498 6.15821C35.3936 4.52019 33.1176 4.12541 29.2256 4.03027C29.6318 4.14189 29.9086 4.54743 29.8356 4.98645C29.4364 7.38093 29.237 8.57817 28.3976 9.28911C27.5584 10.0001 26.3446 10.0001 23.9172 10.0001H20.0826C17.6552 10.0001 16.4414 10.0001 15.6022 9.28911C14.7629 8.57817 14.5634 7.38093 14.1643 4.98645C14.0912 4.54743 14.368 4.14191 14.7743 4.03027C10.8822 4.12543 8.60634 4.52023 7.05026 6.15821Z"
      fill="#ECE9EC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.8834 2.5H25.1166C28.3174 2.49996 30.8798 2.49992 32.891 2.78456C34.9782 3.07992 36.6906 3.70754 38.0372 5.12504C39.3736 6.53168 39.9558 8.30232 40.2316 10.4616C40.5 12.5632 40.5 15.2471 40.5 18.6298V25C40.5 25.8284 39.8284 26.5 39 26.5C38.1716 26.5 37.5 25.8284 37.5 25V18.7368C37.5 15.223 37.4972 12.7311 37.2558 10.8417C37.019 8.98798 36.5762 7.9428 35.8622 7.19128C35.1586 6.4506 34.196 5.99914 32.4708 5.75496C30.694 5.50352 28.3444 5.5 25 5.5H19C15.6556 5.5 13.306 5.50352 11.5293 5.75496C9.80394 5.99914 8.8414 6.4506 8.13776 7.19128C7.42382 7.9428 6.98096 8.98798 6.7442 10.8417C6.50288 12.7311 6.5 15.223 6.5 18.7368V29.2632C6.5 32.777 6.50288 35.269 6.7442 37.1584C6.98096 39.012 7.42382 40.0572 8.13776 40.8088C8.8414 41.5494 9.80392 42.0008 11.5293 42.245C13.306 42.4966 15.6556 42.5 19 42.5H25C25.8284 42.5 26.5 43.1716 26.5 44C26.5 44.8284 25.8284 45.5 25 45.5H18.8834C15.6826 45.5 13.1202 45.5002 11.1089 45.2154C9.02188 44.9202 7.30936 44.2924 5.96276 42.875C4.62644 41.4684 4.04416 39.6978 3.76838 37.5384C3.49994 35.4368 3.49998 32.753 3.5 29.3702V18.6297C3.49998 15.2471 3.49994 12.5632 3.76838 10.4616C4.04416 8.30232 4.62644 6.53168 5.96276 5.12504C7.30936 3.70754 9.02188 3.07992 11.1089 2.78456C13.1202 2.49992 15.6826 2.49996 18.8834 2.5Z"
      fill="#7A010E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.9394 30.9394C31.5252 30.3536 32.4748 30.3536 33.0606 30.9394L38 35.8788L42.9394 30.9394C43.5252 30.3536 44.4748 30.3536 45.0606 30.9394C45.6464 31.5252 45.6464 32.4749 45.0606 33.0605L40.1213 37.9999L45.0606 42.9394C45.6464 43.5252 45.6464 44.4749 45.0606 45.0605C44.4748 45.6463 43.5252 45.6463 42.9394 45.0605L38 40.1214L33.0606 45.0605C32.4748 45.6463 31.5252 45.6463 30.9394 45.0605C30.3536 44.4749 30.3536 43.5252 30.9394 42.9394L35.8786 37.9999L30.9394 33.0605C30.3536 32.4749 30.3536 31.5252 30.9394 30.9394Z"
      fill="#7A010E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7536 2.52064C14.5708 2.38446 15.3436 2.93648 15.4798 3.75364L15.6442 4.74002C15.8501 5.97526 15.9844 6.7643 16.1561 7.34128C16.316 7.87814 16.4588 8.0488 16.572 8.14476C16.6853 8.24074 16.8771 8.35352 17.433 8.42292C18.0303 8.4975 18.8307 8.50024 20.083 8.50024H23.9174C25.1698 8.50024 25.97 8.4975 26.5674 8.42292C27.1232 8.35352 27.315 8.24074 27.4284 8.14476C27.5416 8.0488 27.6844 7.87814 27.8442 7.34128C28.016 6.7643 28.1504 5.97526 28.3562 4.74004L28.5206 3.75364C28.6568 2.93648 29.4296 2.38446 30.2468 2.52064C31.064 2.65684 31.616 3.42968 31.4798 4.24684L31.3008 5.32054C31.1138 6.44306 30.9512 7.41942 30.7196 8.1973C30.47 9.03542 30.0934 9.81886 29.3676 10.4338C28.6416 11.0488 27.8068 11.2915 26.9392 11.3998C26.1338 11.5004 25.144 11.5003 24.006 11.5002C23.9766 11.5002 23.947 11.5002 23.9174 11.5002H20.083C20.0534 11.5002 20.0238 11.5002 19.9945 11.5002C18.8565 11.5003 17.8667 11.5004 17.0613 11.3998C16.1936 11.2915 15.3589 11.0488 14.6329 10.4338C13.907 9.81886 13.5304 9.03542 13.2809 8.1973C13.0493 7.41942 12.8866 6.44308 12.6996 5.32054C12.6947 5.29154 12.6899 5.26244 12.685 5.23322L12.5206 4.24684C12.3844 3.42968 12.9365 2.65684 13.7536 2.52064Z"
      fill="#7A010E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 22C12.5 21.1716 13.1716 20.5 14 20.5H30C30.8284 20.5 31.5 21.1716 31.5 22C31.5 22.8284 30.8284 23.5 30 23.5H14C13.1716 23.5 12.5 22.8284 12.5 22ZM12.5 32C12.5 31.1716 13.1716 30.5 14 30.5H22C22.8284 30.5 23.5 31.1716 23.5 32C23.5 32.8284 22.8284 33.5 22 33.5H14C13.1716 33.5 12.5 32.8284 12.5 32Z"
      fill="#7A010E"
    />
  </svg>
);

export const UnsuspendIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05026 6.15821C5 8.31637 5 11.7899 5 18.7369V29.2632C5 36.2102 5 39.6838 7.05026 41.842C9.1005 44 12.4003 44 19 44H25C31.5996 44 34.8994 44 36.9498 41.842C39 39.6838 39 36.2102 39 29.2632V18.7369C39 11.7899 39 8.31637 36.9498 6.15821C35.3936 4.52019 33.1176 4.12541 29.2256 4.03027C29.6318 4.14189 29.9086 4.54743 29.8356 4.98645C29.4364 7.38093 29.237 8.57817 28.3976 9.28911C27.5584 10.0001 26.3446 10.0001 23.9172 10.0001H20.0826C17.6552 10.0001 16.4414 10.0001 15.6022 9.28911C14.7629 8.57817 14.5634 7.38093 14.1643 4.98645C14.0912 4.54743 14.368 4.14191 14.7743 4.03027C10.8822 4.12543 8.60634 4.52023 7.05026 6.15821Z"
      fill="#ECE9EC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.1166 2.5H18.8834C15.6826 2.49996 13.1202 2.49992 11.1089 2.78458C9.02188 3.07994 7.30936 3.70756 5.96276 5.12504C4.62644 6.53168 4.04416 8.30234 3.76838 10.4616C3.49994 12.5632 3.49998 15.2471 3.5 18.6297V29.3702C3.49998 32.753 3.49994 35.4368 3.76838 37.5384C4.04416 39.6976 4.62644 41.4684 5.96276 42.875C7.30936 44.2924 9.02188 44.92 11.1089 45.2154C13.1202 45.5 15.6826 45.5 18.8834 45.5H22C22.8284 45.5 23.5 44.8284 23.5 44C23.5 43.1716 22.8284 42.5 22 42.5H19C15.6556 42.5 13.306 42.4964 11.5293 42.245C9.80394 42.0008 8.8414 41.5494 8.13776 40.8088C7.42382 40.0572 6.98096 39.012 6.7442 37.1582C6.50288 35.269 6.5 32.777 6.5 29.2632V18.7368C6.5 15.223 6.50288 12.7311 6.7442 10.8417C6.98096 8.98798 7.42382 7.9428 8.13776 7.19128C8.8414 6.45062 9.80394 5.99916 11.5293 5.75498C11.9088 5.70126 12.3145 5.65886 12.7504 5.6254C12.9169 6.62024 13.0704 7.49052 13.2807 8.19708C13.5302 9.0352 13.9068 9.81864 14.6328 10.4336C15.3587 11.0486 16.1934 11.2913 17.0612 11.3996C17.8665 11.5001 18.8563 11.5001 19.9943 11.5H24.0058C25.1438 11.5001 26.1336 11.5001 26.939 11.3996C27.8068 11.2913 28.6414 11.0486 29.3674 10.4336C30.0934 9.81864 30.47 9.0352 30.7194 8.19708C30.9298 7.49054 31.0834 6.62024 31.2498 5.62542C31.6856 5.65888 32.0912 5.70128 32.4708 5.75498C34.196 5.99916 35.1586 6.45062 35.8622 7.19128C36.5762 7.9428 37.019 8.98798 37.2558 10.8417C37.4972 12.7311 37.5 15.223 37.5 18.7368V26C37.5 26.8284 38.1716 27.5 39 27.5C39.8284 27.5 40.5 26.8284 40.5 26V18.6298C40.5 15.2471 40.5 12.5632 40.2316 10.4616C39.9558 8.30234 39.3736 6.53168 38.0372 5.12504C36.6906 3.70756 34.9782 3.07994 32.891 2.78458C30.8798 2.49992 28.3174 2.49996 25.1166 2.5ZM16.156 7.34106C16.0231 6.89464 15.9127 6.32128 15.7741 5.51254C16.735 5.50046 17.8039 5.5 19 5.5H25C26.1962 5.5 27.2652 5.50046 28.226 5.51254C28.0876 6.32128 27.977 6.89464 27.8442 7.34106C27.6844 7.87792 27.5416 8.04858 27.4282 8.14454C27.315 8.24052 27.1232 8.35332 26.5674 8.4227C25.97 8.4973 25.1696 8.50002 23.9174 8.50002H20.0828C18.8306 8.50002 18.0302 8.4973 17.4328 8.4227C16.877 8.35332 16.6852 8.24052 16.5719 8.14454C16.4586 8.04858 16.3158 7.87792 16.156 7.34106Z"
      fill="#005229"
    />
    <path
      d="M44.414 31.499C44.6906 32.28 44.2816 33.1372 43.5008 33.4138C42.3474 33.8222 41.0586 34.6826 39.7316 35.8464C38.4202 36.9966 37.1516 38.3712 36.0342 39.7108C34.9196 41.0468 33.9738 42.3254 33.3064 43.2712C32.9732 43.7432 32.7106 44.1304 32.5324 44.3978C32.4434 44.5316 32.3754 44.6352 32.3306 44.7044L32.2804 44.7818L32.2688 44.8L32.2662 44.804C31.9764 45.26 31.463 45.5256 30.9232 45.4978C30.3834 45.4702 29.9002 45.1542 29.6584 44.6706C28.7474 42.8486 27.9044 42.0722 27.418 41.748C27.1734 41.5848 27.0026 41.525 26.9316 41.5046C26.9184 41.5008 26.908 41.4982 26.9008 41.4966C26.1186 41.4456 25.5 40.795 25.5 39.9998C25.5 39.1714 26.1716 38.4998 27 38.4998V39.9998C27 38.4998 27.003 38.4998 27.003 38.4998H27.006H27.0122L27.025 38.5L27.0534 38.5008C27.0734 38.5014 27.0954 38.5024 27.1196 38.504C27.1678 38.507 27.2242 38.5122 27.288 38.5208C27.4162 38.5378 27.5736 38.568 27.7558 38.62C28.1224 38.7248 28.5766 38.9148 29.082 39.2518C29.7088 39.6696 30.3904 40.2968 31.0768 41.2296C31.7588 40.2764 32.6702 39.06 33.7306 37.789C34.9072 36.3784 36.2856 34.8782 37.7536 33.5908C39.206 32.3172 40.8292 31.1774 42.4992 30.586C43.2802 30.3094 44.1374 30.7182 44.414 31.499Z"
      fill="#005229"
    />
    <path
      d="M14 20.5C13.1716 20.5 12.5 21.1716 12.5 22C12.5 22.8284 13.1716 23.5 14 23.5H30C30.8284 23.5 31.5 22.8284 31.5 22C31.5 21.1716 30.8284 20.5 30 20.5H14Z"
      fill="#005229"
    />
    <path
      d="M14 30.5C13.1716 30.5 12.5 31.1716 12.5 32C12.5 32.8284 13.1716 33.5 14 33.5H22C22.8284 33.5 23.5 32.8284 23.5 32C23.5 31.1716 22.8284 30.5 22 30.5H14Z"
      fill="#005229"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.8333 0.99707V2.19757C3.81666 2.3996 3.96506 2.57768 4.16678 2.59774H6.83455C7.03628 2.57768 7.18467 2.3996 7.16803 2.19757V0.99707"
      stroke="#0F0E10"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16602 11.0014H6.83379"
      stroke="#0F0E10"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.16749 13.0021H2.83194C2.09525 13.0021 1.49805 12.4049 1.49805 11.6682V2.33096C1.49805 1.59427 2.09525 0.99707 2.83194 0.99707H8.16749C8.90418 0.99707 9.50138 1.59427 9.50138 2.33096V11.6682C9.50138 12.4049 8.90418 13.0021 8.16749 13.0021Z"
      stroke="#0F0E10"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon2 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18.0031H13.0017"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.003 13.0003V19.0028C17.003 20.1078 16.1072 21.0036 15.0022 21.0036H6.99888C5.89385 21.0036 4.99805 20.1078 4.99805 19.0028V4.99693C4.99805 3.8919 5.89385 2.99609 6.99888 2.99609H10.0001"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.337 5.33008L16.6703 6.99777L15.6699 5.99736"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0045 9.99943H15.0028C13.8978 9.99943 13.002 9.10362 13.002 7.99859V3.99693C13.002 2.8919 13.8978 1.99609 15.0028 1.99609H19.0045C20.1095 1.99609 21.0053 2.8919 21.0053 3.99693V7.99859C21.0053 9.10362 20.1095 9.99943 19.0045 9.99943Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 0.5C10.976 0.5 14 3.524 14 7.25C14 10.976 10.976 14 7.25 14C3.524 14 0.5 10.976 0.5 7.25C0.5 3.524 3.524 0.5 7.25 0.5ZM7.25 12.5C10.1502 12.5 12.5 10.1502 12.5 7.25C12.5 4.349 10.1502 2 7.25 2C4.349 2 2 4.349 2 7.25C2 10.1502 4.349 12.5 7.25 12.5ZM13.6137 12.5532L15.7355 14.6742L14.6742 15.7355L12.5532 13.6137L13.6137 12.5532Z"
      fill="#868C98"
    />
  </svg>
);

export const OfficeIcon = (size: string) => (
  <svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_691)" filter="url(#filter0_i_23_691)">
      <g filter="url(#filter1_b_23_691)">
        <rect
          x="8"
          y="25.7572"
          width="30.3996"
          height="62.4002"
          rx="1.99999"
          fill="url(#paint0_radial_23_691)"
        />
        <rect
          x="8.5"
          y="26.2572"
          width="29.3996"
          height="61.4002"
          rx="1.49999"
          stroke="url(#paint1_radial_23_691)"
          strokeWidth="0.999995"
        />
      </g>
      <rect
        x="14.4"
        y="32.5"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="14.4"
        y="43.7"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="14.4"
        y="54.9"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <g filter="url(#filter2_bdi_23_691)">
        <rect
          x="24"
          y="13.3"
          width="30.3996"
          height="62.4002"
          rx="1.99999"
          fill="url(#paint2_radial_23_691)"
          shape-rendering="crispEdges"
        />
        <rect
          x="24.5"
          y="13.8"
          width="29.3996"
          height="61.4002"
          rx="1.49999"
          stroke="url(#paint3_radial_23_691)"
          strokeWidth="0.999995"
          shape-rendering="crispEdges"
        />
      </g>
      <rect
        x="30.4"
        y="20.0427"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="30.4"
        y="31.2429"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="30.4"
        y="42.443"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="30.4"
        y="53.6429"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="41.6"
        y="20.0427"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="41.6"
        y="31.2429"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="41.6"
        y="42.443"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
      <rect
        x="41.6"
        y="53.6429"
        width="6.39992"
        height="6.40002"
        rx="0.5"
        fill="#F1F1F4"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_23_691"
        x="0"
        y="-7.5"
        width="64"
        height="72"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-8" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.7712 0 0 0 0 0.78 0 0 0 0 0.7888 0 0 0 0.48 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_23_691"
        />
      </filter>
      <filter
        id="filter1_b_23_691"
        x="4.00002"
        y="21.7572"
        width="38.3996"
        height="70.4001"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.99999" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_23_691"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_23_691"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_bdi_23_691"
        x="20"
        y="5.30005"
        width="38.3996"
        height="78.4001"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.99999" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_23_691"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.541176 0 0 0 0 0.560784 0 0 0 0 0.576471 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_23_691"
          result="effect2_dropShadow_23_691"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_23_691"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-8" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect3_innerShadow_23_691"
        />
      </filter>
      <radialGradient
        id="paint0_radial_23_691"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.1998 25.7572) rotate(90) scale(70.4002 34.297)"
      >
        <stop offset="0.45232" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_23_691"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.1998 25.7572) rotate(90) scale(62.4002 30.3996)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_23_691"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.1998 13.3) rotate(90) scale(70.4002 34.297)"
      >
        <stop offset="0.45232" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_23_691"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.1998 13.3) rotate(90) scale(62.4002 30.3996)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <clipPath id="clip0_23_691">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CopyIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.5H15.1C17.3402 3.5 18.4603 3.5 19.316 3.93597C20.0686 4.31947 20.6805 4.93139 21.064 5.68404C21.5 6.53969 21.5 7.65979 21.5 9.9V17M6.7 21.5H14.8C15.9201 21.5 16.4802 21.5 16.908 21.282C17.2843 21.0903 17.5903 20.7843 17.782 20.408C18 19.9802 18 19.4201 18 18.3V10.2C18 9.07989 18 8.51984 17.782 8.09202C17.5903 7.71569 17.2843 7.40973 16.908 7.21799C16.4802 7 15.9201 7 14.8 7H6.7C5.5799 7 5.01984 7 4.59202 7.21799C4.21569 7.40973 3.90973 7.71569 3.71799 8.09202C3.5 8.51984 3.5 9.07989 3.5 10.2V18.3C3.5 19.4201 3.5 19.9802 3.71799 20.408C3.90973 20.7843 4.21569 21.0903 4.59202 21.282C5.01984 21.5 5.5799 21.5 6.7 21.5Z"
      stroke="#E255F2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CopyIcon2 = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6120_8589)">
      <path
        d="M7.33398 14.6673V17.234C7.33398 18.2607 7.33398 18.7741 7.53381 19.1663C7.70957 19.5113 7.99004 19.7917 8.335 19.9675C8.72717 20.1673 9.24055 20.1673 10.2673 20.1673H17.234C18.2607 20.1673 18.7741 20.1673 19.1663 19.9675C19.5113 19.7917 19.7917 19.5113 19.9675 19.1663C20.1673 18.7741 20.1673 18.2607 20.1673 17.234V10.2673C20.1673 9.24055 20.1673 8.72717 19.9675 8.335C19.7917 7.99004 19.5113 7.70957 19.1663 7.53381C18.7741 7.33398 18.2607 7.33398 17.234 7.33398H14.6673M4.76732 14.6673H11.734C12.7607 14.6673 13.2741 14.6673 13.6663 14.4675C14.0113 14.2917 14.2917 14.0113 14.4675 13.6663C14.6673 13.2741 14.6673 12.7607 14.6673 11.734V4.76732C14.6673 3.74055 14.6673 3.22717 14.4675 2.835C14.2917 2.49004 14.0113 2.20957 13.6663 2.03381C13.2741 1.83398 12.7607 1.83398 11.734 1.83398H4.76732C3.74055 1.83398 3.22717 1.83398 2.835 2.03381C2.49004 2.20957 2.20957 2.49004 2.03381 2.835C1.83398 3.22717 1.83398 3.74055 1.83398 4.76732V11.734C1.83398 12.7607 1.83398 13.2741 2.03381 13.6663C2.20957 14.0113 2.49004 14.2917 2.835 14.4675C3.22717 14.6673 3.74055 14.6673 4.76732 14.6673Z"
        stroke="black"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6120_8589">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DataIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.8C10 6.51997 10 6.37996 10.0545 6.273C10.1024 6.17892 10.1789 6.10243 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.10243 13.8976 6.17892 13.9455 6.273C14 6.37996 14 6.51997 14 6.8V9.2C14 9.48003 14 9.62004 13.9455 9.727C13.8976 9.82108 13.8211 9.89757 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.89757 10.1024 9.82108 10.0545 9.727C10 9.62004 10 9.48003 10 9.2V6.8Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12.8C3 12.52 3 12.38 3.0545 12.273C3.10243 12.1789 3.17892 12.1024 3.273 12.0545C3.37996 12 3.51997 12 3.8 12H6.2C6.48003 12 6.62004 12 6.727 12.0545C6.82108 12.1024 6.89757 12.1789 6.9455 12.273C7 12.38 7 12.52 7 12.8V15.2C7 15.48 7 15.62 6.9455 15.727C6.89757 15.8211 6.82108 15.8976 6.727 15.9455C6.62004 16 6.48003 16 6.2 16H3.8C3.51997 16 3.37996 16 3.273 15.9455C3.17892 15.8976 3.10243 15.8211 3.0545 15.727C3 15.62 3 15.48 3 15.2V12.8Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 2.8C2 2.51997 2 2.37996 2.0545 2.273C2.10243 2.17892 2.17892 2.10243 2.273 2.0545C2.37996 2 2.51997 2 2.8 2H5.2C5.48003 2 5.62004 2 5.727 2.0545C5.82108 2.10243 5.89757 2.17892 5.9455 2.273C6 2.37996 6 2.51997 6 2.8V5.2C6 5.48003 6 5.62004 5.9455 5.727C5.89757 5.82108 5.82108 5.89757 5.727 5.9455C5.62004 6 5.48003 6 5.2 6H2.8C2.51997 6 2.37996 6 2.273 5.9455C2.17892 5.89757 2.10243 5.82108 2.0545 5.727C2 5.62004 2 5.48003 2 5.2V2.8Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotificationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M13 17H7M15 13H7M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z"
      stroke="#3D003B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9.5 4.5L11 3M11 3L9.5 1.5M11 3L8 3M8 10.5V9.9C8 9.05992 8 8.63988 7.83651 8.31901C7.6927 8.03677 7.46323 7.8073 7.18099 7.66349C6.86012 7.5 6.44008 7.5 5.6 7.5H3.4C2.55992 7.5 2.13988 7.5 1.81901 7.66349C1.53677 7.8073 1.3073 8.03677 1.16349 8.31901C1 8.63988 1 9.05992 1 9.9V10.5M6.25 3.75C6.25 4.7165 5.4665 5.5 4.5 5.5C3.5335 5.5 2.75 4.7165 2.75 3.75C2.75 2.7835 3.5335 2 4.5 2C5.4665 2 6.25 2.7835 6.25 3.75Z"
      stroke="#320B30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const Coins = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V9.45715C11.7785 9.82398 11 10.3789 11 11M2 5V17C2 18.1046 4.46243 19 7.5 19C8.82963 19 10.0491 18.8284 11 18.5429V11M2 9C2 10.1046 4.46243 11 7.5 11C8.82963 11 10.0491 10.8284 11 10.5429M2 13C2 14.1046 4.46243 15 7.5 15C8.82963 15 10.0491 14.8284 11 14.5429M22 11C22 12.1046 19.5376 13 16.5 13C13.4624 13 11 12.1046 11 11M22 11C22 9.89543 19.5376 9 16.5 9C13.4624 9 11 9.89543 11 11M22 11V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11M22 15C22 16.1046 19.5376 17 16.5 17C13.4624 17 11 16.1046 11 15" stroke="#3D003B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const AnnotationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V9C14 9.93188 14 10.3978 13.8478 10.7654C13.6448 11.2554 13.2554 11.6448 12.7654 11.8478C12.3978 12 11.9319 12 11 12C10.6743 12 10.5114 12 10.3603 12.0357C10.1589 12.0832 9.97126 12.177 9.81234 12.3097C9.69315 12.4091 9.59543 12.5394 9.4 12.8L8.42667 14.0978C8.28192 14.2908 8.20955 14.3873 8.12082 14.4218C8.04311 14.452 7.95689 14.452 7.87918 14.4218C7.79045 14.3873 7.71808 14.2908 7.57333 14.0978L6.6 12.8C6.40457 12.5394 6.30685 12.4091 6.18766 12.3097C6.02874 12.177 5.84113 12.0832 5.63967 12.0357C5.48858 12 5.32572 12 5 12C4.06812 12 3.60218 12 3.23463 11.8478C2.74458 11.6448 2.35523 11.2554 2.15224 10.7654C2 10.3978 2 9.93188 2 9V5.2Z" stroke="#A1A5AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const BriefcaseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3334 5.83333C13.3334 5.05836 13.3334 4.67087 13.2482 4.35295C13.0171 3.49022 12.3432 2.81635 11.4805 2.58519C11.1625 2.5 10.7751 2.5 10.0001 2.5C9.2251 2.5 8.83762 2.5 8.5197 2.58519C7.65697 2.81635 6.9831 3.49022 6.75193 4.35295C6.66675 4.67087 6.66675 5.05836 6.66675 5.83333M4.33342 17.5H15.6667C16.6002 17.5 17.0669 17.5 17.4234 17.3183C17.737 17.1586 17.992 16.9036 18.1518 16.59C18.3334 16.2335 18.3334 15.7668 18.3334 14.8333V8.5C18.3334 7.56658 18.3334 7.09987 18.1518 6.74335C17.992 6.42975 17.737 6.17478 17.4234 6.01499C17.0669 5.83333 16.6002 5.83333 15.6667 5.83333H4.33341C3.39999 5.83333 2.93328 5.83333 2.57676 6.01499C2.26316 6.17478 2.00819 6.42975 1.8484 6.74335C1.66675 7.09987 1.66675 7.56658 1.66675 8.5V14.8333C1.66675 15.7668 1.66675 16.2335 1.8484 16.59C2.00819 16.9036 2.26316 17.1586 2.57676 17.3183C2.93328 17.5 3.39999 17.5 4.33342 17.5Z" stroke="#A1A5AD" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const PhoneIcon1 = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99996 14.5832H10.0083M6.83329 18.3332H13.1666C14.1 18.3332 14.5668 18.3332 14.9233 18.1515C15.2369 17.9917 15.4918 17.7368 15.6516 17.4232C15.8333 17.0666 15.8333 16.5999 15.8333 15.6665V4.33317C15.8333 3.39975 15.8333 2.93304 15.6516 2.57652C15.4918 2.26292 15.2369 2.00795 14.9233 1.84816C14.5668 1.6665 14.1 1.6665 13.1666 1.6665H6.83329C5.89987 1.6665 5.43316 1.6665 5.07664 1.84816C4.76304 2.00795 4.50807 2.26292 4.34828 2.57652C4.16663 2.93304 4.16663 3.39975 4.16663 4.33317V15.6665C4.16663 16.5999 4.16663 17.0666 4.34828 17.4232C4.50807 17.7368 4.76304 17.9917 5.07664 18.1515C5.43316 18.3332 5.89987 18.3332 6.83329 18.3332ZM10.4166 14.5832C10.4166 14.8133 10.2301 14.9998 9.99996 14.9998C9.76984 14.9998 9.58329 14.8133 9.58329 14.5832C9.58329 14.3531 9.76984 14.1665 9.99996 14.1665C10.2301 14.1665 10.4166 14.3531 10.4166 14.5832Z" stroke="#A1A5AD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const PasscodeIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.99996 9.99992H10.0041M14.1666 9.99992H14.1708M5.83329 9.99992H5.83746M4.33329 5.83325H15.6666C16.6 5.83325 17.0668 5.83325 17.4233 6.01491C17.7369 6.1747 17.9918 6.42966 18.1516 6.74327C18.3333 7.09979 18.3333 7.5665 18.3333 8.49992V11.4999C18.3333 12.4333 18.3333 12.9001 18.1516 13.2566C17.9918 13.5702 17.7369 13.8251 17.4233 13.9849C17.0668 14.1666 16.6 14.1666 15.6666 14.1666H4.33329C3.39987 14.1666 2.93316 14.1666 2.57664 13.9849C2.26304 13.8251 2.00807 13.5702 1.84828 13.2566C1.66663 12.9001 1.66663 12.4333 1.66663 11.4999V8.49992C1.66663 7.5665 1.66663 7.09979 1.84828 6.74327C2.00807 6.42966 2.26304 6.1747 2.57664 6.01491C2.93316 5.83325 3.39987 5.83325 4.33329 5.83325ZM10.2083 9.99992C10.2083 10.115 10.115 10.2083 9.99996 10.2083C9.8849 10.2083 9.79163 10.115 9.79163 9.99992C9.79163 9.88486 9.8849 9.79159 9.99996 9.79159C10.115 9.79159 10.2083 9.88486 10.2083 9.99992ZM14.375 9.99992C14.375 10.115 14.2817 10.2083 14.1666 10.2083C14.0516 10.2083 13.9583 10.115 13.9583 9.99992C13.9583 9.88486 14.0516 9.79159 14.1666 9.79159C14.2817 9.79159 14.375 9.88486 14.375 9.99992ZM6.04163 9.99992C6.04163 10.115 5.94835 10.2083 5.83329 10.2083C5.71823 10.2083 5.62496 10.115 5.62496 9.99992C5.62496 9.88486 5.71823 9.79159 5.83329 9.79159C5.94835 9.79159 6.04163 9.88486 6.04163 9.99992Z" stroke="#A1A5AD" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
</svg>
)
export const AnnotationHeartIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.5 6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V11.25C17.5 12.4149 17.5 12.9973 17.3097 13.4567C17.056 14.0693 16.5693 14.556 15.9567 14.8097C15.4973 15 14.9149 15 13.75 15C13.3429 15 13.1393 15 12.9504 15.0446C12.6986 15.104 12.4641 15.2213 12.2654 15.3871C12.1164 15.5114 11.9943 15.6743 11.75 16L10.5333 17.6222C10.3524 17.8635 10.2619 17.9841 10.151 18.0272C10.0539 18.065 9.94611 18.065 9.84897 18.0272C9.73806 17.9841 9.6476 17.8635 9.46667 17.6222L8.25 16C8.00571 15.6743 7.88357 15.5114 7.73458 15.3871C7.53593 15.2213 7.30141 15.104 7.04959 15.0446C6.86072 15 6.65715 15 6.25 15C5.08515 15 4.50272 15 4.04329 14.8097C3.43072 14.556 2.94404 14.0693 2.6903 13.4567C2.5 12.9973 2.5 12.4149 2.5 11.25V6.5Z" stroke="#A1A5AD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99772 6.94216C9.33127 6.18467 8.21991 5.9809 7.3849 6.67454C6.54988 7.36818 6.43232 8.52791 7.08807 9.34828C7.478 9.83611 8.43307 10.7109 9.14327 11.3399C9.43644 11.5996 9.58302 11.7294 9.75946 11.7821C9.91042 11.8271 10.085 11.8271 10.236 11.7821C10.4124 11.7294 10.559 11.5996 10.8522 11.3399C11.5624 10.7109 12.5174 9.83611 12.9074 9.34828C13.5631 8.52791 13.4599 7.36088 12.6105 6.67454C11.7612 5.9882 10.6642 6.18467 9.99772 6.94216Z" stroke="#A1A5AD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
)

export const CustomTimerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
<path d="M6.5 0.25C3.05375 0.25 0.25 3.05375 0.25 6.5C0.25 9.94625 3.05375 12.75 6.5 12.75C9.94625 12.75 12.75 9.94625 12.75 6.5C12.75 3.05375 9.94625 0.25 6.5 0.25ZM8.55813 9.44188L5.875 6.75875V2.75H7.125V6.24125L9.44188 8.55813L8.55813 9.44188Z" fill="#94A7B7"/>
</svg>
)